import { render } from "./index.vue?vue&type=template&id=24653b17&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=24653b17&lang=less&scoped=true"
import "./index.vue?vue&type=style&index=1&id=24653b17&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/carbon-rating-admin-site-CI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24653b17"]])

export default __exports__